import {createFeatureSelector, createSelector} from "@ngrx/store";
import {DbStoreState} from "../reducers";
import {IKnowledgeBaseState} from "../reducers/knowledge-base.reducer";

const getDbStoreState = createFeatureSelector<DbStoreState>('dbStore');

export const getKnowledgeBaseState = createSelector(getDbStoreState, (dbStoreState: DbStoreState) => dbStoreState.knowledgeBase);


export const getKnowledgeBaseToggled = createSelector(getKnowledgeBaseState,
  (state: IKnowledgeBaseState): boolean =>
    state.toggled
);
